export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-lead-list-item.vue?vue&type=template&id=227e0d04&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-leads-list/lk-lead-list-item.vue?vue&type=template&id=227e0d04&
// module id = 1447
// module chunks = 0